uic-app-header {
  display: block;
  height: var(--uic-header-height);
  width: 100%;

  uic-header {
    left: 0;
    position: fixed;
    top: 0;
  }
}
